import request from '@/utils/request'

// 创建产品账户
export const addProductAccount = (data: any) =>
  request({
    url: '/manage/product-account',
    method: 'post',
    data
  })

// 删除产品账户
export const delProductAccount = (data: any) =>
  request({
    url: '/manage/product-account/' + data.id,
    method: 'delete',
    data
  })

// 编辑产品账户
export const setProductAccount = (data: any) =>
  request({
    url: '/manage/product-account/' + data.id,
    method: 'patch',
    data
  })

// 获取产品账户列表，有分页
export const getProductAccountList = (params: any) =>
  request({
    url: '/manage/product-account',
    method: 'get',
    params
  })

// 获取产品账户列表，无分页
export const getProductAccountListNoPage = (params: any) =>
  request({
    url: '/manage/product-account',
    method: 'get',
    params
  })

// 获取产品账户详情
export const getProductAccount = (params: any) =>
  request({
    url: '/manage/product-account/' + params,
    method: 'get'
  })

// 创建钱包
export const addWallet = (data: any) =>
  request({
    url: '/manage/wallet-address',
    method: 'post',
    data
  })

// 编辑钱包
export const editWallet = (data: any) =>
  request({
    url: '/manage/wallet-address/' + data.address,
    method: 'patch',
    data
  })

// 删除钱包
export const delWallet = (data: any) =>
  request({
    url: '/manage/wallet-address/' + data.address,
    method: 'delete',
    data
  })

// 获取钱包详情
export const walletDetails = (params: any) =>
  request({
    url: '/manage/wallet-address/' + params,
    method: 'get'
  })

// 产品账户列表（无分页）
export const newProductAccount = (params: any) =>
  request({
    url: '/manage/product-account-list',
    method: 'get',
    params
  })

// 专用商户账户
export const dedicatedMerchantAccount = (data: any) =>
  request({
    url: '/manage/merchant-dedicated-product-account/' + data.id,
    method: 'patch',
    data
  })

// 账户统计
export const getAccountStatistics = (params: any) =>
  request({
    url: '/manage/product-account/' + params.id + '/collect-report',
    method: 'get',
    params
  })

export const aloneSetConfig = (data: any) =>
  request({
    url: '/manage/product-account/extra-param',
    method: 'post',
    data
  })

// 关闭熔断
export const closeCircuitbBreaker = (data: any) =>
  request({
    url: '/manage/product-account/' + data.id + '/circuit-breaker',
    method: 'put',
    data
  })

// 分享账户
export const shareAccount = (data: any) =>
  request({
    url: `/manage/share-account`,
    method: 'post',
    data
  })

// 账户统计接口
export const getAccountStatistic = (params: any) =>
  request({
    url: `/manage/product/${params.id}/config`,
    method: 'get',
    params
  })

// 产品详情接口
export const getProductInfo = (params: any) =>
  request({
    url: `/manage/product/${params.id}`,
    method: 'get',
    params
  })

// 服务器插件操作
export const getServerSidePlugin = (data: any) =>
  request({
    url: `/manage/server-side-plugin`,
    method: 'post',
    data,
    timeout: 60000
  })

// 插件loading状态查询
export const getLoadingState = (params: any) =>
  request({
    url: `/manage/product-account/${params.id}/loadind-state`,
    method: 'get',
    params
  })

// 申请插件账户日志
export const getAccountKey = (data: any) =>
  request({
    url: `/manage/product-account/${data.id}/plugin-log`,
    method: 'patch',
    data
  })

// 申请插件账户日志
export const getAccountLog = (params: any) =>
  request({
    url: `/manage/product-account/${params.id}/plugin-log`,
    method: 'get',
    params
  })

// 查询下次结算时间
export const getSettlementTime = (data: any) =>
  request({
    url: `/manage/next-settlement-time`,
    method: 'post',
    data
  })

// 账户批量编辑限制接口
export const setBatchEditLimit = (data: any) =>
  request({
    url: `/manage/product-accounts-batch-update`,
    method: 'patch',
    data
  })

// 批量删除产品账户
export const delProductAccounts = (data: any) =>
  request({
    url: '/manage/product-accounts-batch-delete',
    method: 'delete',
    data
  })

// 批量启用/重启/停用
export const batchEnable = (data: any) =>
  request({
    url: '/manage/server-side-plugin-batch-start',
    method: 'post',
    data
  })

// 子产品配置
export const getSubProductConfig = (data: any) =>
  request({
    url: `/manage/product/${data.id}`,
    method: 'patch',
    data
  })
